'use client';
import { cn } from '~/lib/utils';

export const Badge = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return (
    <div
      className={cn(
        'px-2 py-0.5 rounded-full bg-primary-400/20 text-primary-300 dark:text-primary-500 text-xs w-fit',
        className,
      )}
    >
      {children}
    </div>
  );
};
